import { Link } from "react-router-dom";

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  status: string;
  updateTime: string;
  latestChapter: string;
  tags: string[];
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  status,
  updateTime,
  latestChapter,
  tags,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-100">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 text-[10px] font-semibold rounded bg-primary-500 text-white whitespace-nowrap">
            {rating}
          </span>
        </div>
        {status === "已完结" && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 text-[10px] font-medium rounded bg-background-900/70 text-background-50 whitespace-nowrap">
              {status}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <p className="text-xs text-white font-medium whitespace-nowrap">
            {latestChapter}
          </p>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-900 leading-tight mb-1 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mb-1">{author}</p>
      <div className="flex items-center gap-2 text-xs text-foreground-400">
        <span>{formatViews(views)} 阅读</span>
        <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
        <span>{updateTime}</span>
      </div>
      <div className="flex flex-wrap gap-1 mt-2">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}